export const meterToMile = (val?: number) => {
  return Math.round(((val || 0) / 1609.34) * 100) / 100.0;
};
